/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const DeleteStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M10 9.5L10 17.5M3.5 6H20.5M14 9.5V17.5M6 6H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V6ZM8 6H16V5C16 3.89543 15.1046 3 14 3H10C8.89543 3 8 3.89543 8 5V6Z"
          strokeLinecap="round"
        />
      </svg>
    </Icon>
  );
});

export { DeleteStrokeIcon };
